import BasicResources from './basic-resources';

// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should call its initialise() method, to set
// up the environment and create all of the resources the application will use.

class Resources {
    static createResources(parentEnv) {
        const env = parentEnv || Resources.env; // eslint-disable-line no-unused-
        const schoolRollGateway = '@SchoolRollGatewayUrl';
        const userPortalGateway = '@UserPortalGatewayUrl';

        /**
         * ACTIVITY ASSIGN PREFERENCE
         */
        this.activityAssignPreferences = env.resource('activityAssignPreferences')
            .baseUrl(userPortalGateway)
            .service('/preferences');

        /**
         * PRIVACY SETTINGS
         */
        this.saveSchoolPreferences = env.resource('saveSchoolPreferences')
            .baseUrl(schoolRollGateway)
            .service('api/v1/schools/preferences/{type}');
        this.getUserPortalSettings = env.resource('getUserPortalSettings')
            .baseUrl(userPortalGateway)
            .service('api/v1/settings');
    }

    // Initialise the environment and resources, based on the provided
    // environment name.  We return the environment so the caller has
    // access to everything, in particular the authToken if one was
    // passed in the query parameters.

    static initialise(envName, credentials) {
        Resources.env = BasicResources.initialise(envName, credentials);

        Resources.createResources();

        return Resources.env;
    }
}

export default Resources;



// WEBPACK FOOTER //
// ./app/helpers/resources.js